import { ReactNode } from 'react';

interface V1LayoutProps {
  children: ReactNode;
}

export function V1Layout({ children }: V1LayoutProps) {

  return (
    <div className="min-h-screen bg-background">
      {/* <Sidebar /> */}
      <main className="ml-64 min-h-screen p-8">
        {children}
      </main>
    </div>
  );
}